'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFillContinuous = exports.getFill = exports.getColorContinuous = exports.getColor = exports.defaultColors = undefined;
var _textures = require('textures');
var _textures2 = _interopRequireDefault(_textures);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

// middle, [negative, negative-accent], [positive, positive-accent]
var defaultColors = exports.defaultColors = ['#ddd', ['#9BE', '#229'], ['#CAA', '#900']];
var colorFills = [function (p, colors) {
  return colors[0];
}, function (p, colors) {
  return colors[p ? 2 : 1][0];
}, function (p, colors) {
  return colors[p ? 2 : 1][1];
}, function (p, colors) {
  return colors[p ? 2 : 1][2];
}, function (p, colors) {
  return colors[p ? 2 : 1][2];
}];
var getColor = exports.getColor = function getColor(len, i, colors) {
  var p = polarity(len, i);
  var o = offset(len, i);
  return colorFills[o](p, colors);
};
var lpad = function lpad(s) {
  return s.length == 2 ? s : '0' + s;
};
var hexToInt = function hexToInt(hex) {
  return {
    r: parseInt(hex.slice(1, 3), 16),
    g: parseInt(hex.slice(3, 5), 16),
    b: parseInt(hex.slice(5), 16)
  };
};
var getColorContinuous = exports.getColorContinuous = function getColorContinuous(len, i, colors) {
  var low = hexToInt(colors[0]);
  var high = hexToInt(colors[1]);
  return ['#', lpad(Math.max(Math.round(low.r + (high.r - low.r) * (i + 1) / len), 0).toString(16)), lpad(Math.max(Math.round(low.g + (high.g - low.g) * (i + 1) / len), 0).toString(16)), lpad(Math.max(Math.round(low.b + (high.b - low.b) * (i + 1) / len), 0).toString(16))].join('');
};

// pattern set 
var fillPatterns = [function (p, colors) {
  return _textures2.default.lines().background(colors[0]).stroke('transparent');
}, function (p, colors) {
  return _textures2.default.lines().background(colors[p ? 2 : 1][1]).stroke('transparent');
}, function (p, colors) {
  return _textures2.default.lines().background(colors[p ? 2 : 1][0]).stroke(colors[p ? 2 : 1][1]).size(12).strokeWidth(5).orientation(p ? "2/8" : "6/8");
}, function (p, colors) {
  return _textures2.default.paths().d("woven").lighter().thicker().background(colors[p ? 2 : 1][0]).stroke(colors[p ? 2 : 1][1]);
}, function (p, colors) {
  return _textures2.default.lines().background(colors[p ? 2 : 1][0]).stroke('transparent');
}];
var continuousFillPatterns = [function (color) {
  return _textures2.default.lines().background(color).stroke('transparent');
}, function (color) {
  return _textures2.default.lines().background(color).stroke('rgba(0,0,0,0.3)').size(12).strokeWidth(5).orientation("6/8");
}, function (color) {
  return _textures2.default.paths().d("woven").thicker().background(color).stroke('rgba(0,0,0,0.3)');
}, function (color) {
  return _textures2.default.circles().thicker().thicker().lighter().background(color).fill('rgba(0,0,0,0.3)');
}, function (color) {
  return _textures2.default.lines().background(color).stroke('transparent');
}];
var getFill = exports.getFill = function getFill(len, i, colors) {
  var p = polarity(len, i);
  var o = offset(len, i);
  var reverseOffset = Math.floor(len / 2) - o;

  // offset 0 (center) - use neutral pattern 0
  if (o === 0) return fillPatterns[0](p, colors);
  // else use fill pattern starting at index 1 counting back
  return fillPatterns[reverseOffset + 1](p, colors);
};
var getFillContinuous = exports.getFillContinuous = function getFillContinuous(len, i, colors) {
  return continuousFillPatterns[i](getColorContinuous(len, i, colors));
};

// functions for assigning color / pattern combination
var offset = function offset(len, i) {
  return Math.ceil(Math.abs(i + 1 - (len + 1) / 2));
};
var polarity = function polarity(len, i) {
  return i + 1 - (len + 1) / 2 > 0;
};